// /* eslint-disable @typescript-eslint/naming-convention */
// import _ from 'lodash';
// import React, { useCallback, useContext } from 'react';
// import { withRouter } from 'react-router';
// import { AsyncComponent } from '../../../components/AsyncComponent';
// import { DotsContentMenu } from '../../../components/ContentMenu/DotsContentMenu';
// import { EvenlySpacedItemsList } from '../../../components/EvenlySpacedItemsList';
// import { ContentType } from '../../../enums/ContentType';
// import { AISummaryButton } from '../../../features/ai_summary';
// import { BookContextModel } from '../../../models/book/BookContextModel';
// import { BookEditionChapterModel } from '../../../models/book/BookEditionChapterModel';
// import { BookEditionModel } from '../../../models/book/BookEditionModel';
// import { ContentSearchResult } from '../../../models/ContentSearchResult';
// import { ArticleListItem } from '../../periodico/components/ArticleListItem';
// import { BookContext } from './BookContextProvider';
// import { Icon, Tree } from 'antd';
// import { BookChapterItemModel } from '../../../models/book/BookChapterItemModel';
// import styled from 'styled-components';

// interface IProps {
//   selectedChapterId?: number;
//   match?: any;
//   history?: any;
//   book: BookEditionModel;
//   editionId: number;
//   currentEdition?: any;
// }

// const _BookEditionChapterList = ({
//   selectedChapterId,
//   match,
//   history,
//   book,
//   currentEdition
// }: IProps) => {
//   const { bookId, editionId } = match.params;
//   const ctx = useContext<{ state: BookContextModel }>(BookContext as any);
//   const { editionChaptersRequest } = ctx.state;

//   // const createChapterLink = useCallback(
//   //   (chapterId: any) =>
//   //     `/v2/livro/${bookId || book.id}/${editionId}/${chapterId}`,
//   //   [book, bookId, editionId]
//   // );
//   const createChapterLink = useCallback(
//     (chapterId: any, digitalPage?: number) => {
//       const baseUrl = `/v2/livro/${
//         bookId || book.id
//       }/${editionId}/${chapterId}`;

//       if (digitalPage === undefined || digitalPage === null) {
//         return baseUrl;
//       }

//       return `${baseUrl}?page=${digitalPage}`;
//     },
//     [book, bookId, editionId]
//   );
//   const createContentSearchResultFromChapter = useCallback(
//     (chapter: BookEditionChapterModel) => {
//       if (!book) return ContentSearchResult.Empty;
//       const stage = process.env.REACT_APP_STAGE || 'staging';
//       const imageSrc = `https://bid1006-${stage}-public.s3.sa-east-1.amazonaws.com${book.image}`;
//       return new ContentSearchResult(
//         ContentType.CHAPTER,
//         chapter.id,
//         chapter.title,
//         book.title,
//         book.description,
//         null,
//         editionId,
//         bookId,
//         imageSrc,
//         chapter.author,
//         null,
//         `Atualizado em: ${book.year}`,
//         null,
//         null,
//         book.areasInterest,
//         undefined,
//         String(chapter.id)
//       );
//     },
//     [book]
//   );

//   // const renderChapterItems = useCallback(
//   //   (
//   //     items: BookChapterItemModel[],
//   //     parentChapter: BookEditionChapterModel,
//   //     level = 1
//   //   ): React.ReactNode => {
//   //     if (!items || !items.length) {
//   //       return null;
//   //     }

//   //     return items.map((item, index) => {
//   //       const link = createChapterLink(parentChapter.id, item.digitalPage);

//   //       return (
//   //         <React.Fragment key={`${parentChapter.id}-${item.title}-${index}`}>
//   //           <ArticleListItem
//   //             article={
//   //               new BookEditionChapterModel(
//   //                 parentChapter.id,
//   //                 item.title,
//   //                 parentChapter.author,
//   //                 parentChapter.subtitle,
//   //                 parentChapter.pdfName,
//   //                 parentChapter.titlePresentation,
//   //                 item.items || []
//   //               )
//   //             }
//   //             link={link}
//   //             active={false}
//   //             onClick={() => {
//   //               history.push(link);
//   //             }}
//   //           />

//   //           {item.items && item.items.length > 0
//   //             ? renderChapterItems(item.items, parentChapter, level + 1)
//   //             : null}
//   //         </React.Fragment>
//   //       );
//   //     });
//   //   },
//   //   [createChapterLink, history]
//   // );
//   const renderChapterItems = useCallback(
//     (
//       items: BookChapterItemModel[],
//       parentChapter: BookEditionChapterModel
//     ): React.ReactNode => {
//       if (!items || items.length === 0) {
//         return null;
//       }

//       return (
//         <ChapterItems>
//           {items.map((item, index) => {
//             const link = createChapterLink(parentChapter.id, item.digitalPage);

//             const itemChapter = new BookEditionChapterModel(
//               parentChapter.id,
//               item.title,
//               parentChapter.author,
//               parentChapter.subtitle,
//               parentChapter.pdfName,
//               parentChapter.titlePresentation,
//               item.items || []
//             );

//             const hasSubItems = item.items && item.items.length > 0;

//             return (
//               // Substituído React.Fragment por li (ou div) para manter o pai e os filhos sob o mesmo nó DOM
//               <li
//                 key={`${parentChapter.id}-${item.title}-${index}`}
//                 style={{ listStyle: 'none' }}>
//                 <ArticleListItem
//                   article={itemChapter}
//                   link={link}
//                   active={false}
//                   onClick={() => {
//                     history.push(link);
//                   }}
//                   Menu={
//                     currentEdition && currentEdition.onlyView ? (
//                       <Icon type="lock" style={{ fontSize: 30 }} />
//                     ) : (
//                       <DotsContentMenu
//                         result={createContentSearchResultFromChapter(
//                           parentChapter
//                         )}
//                       />
//                     )
//                   }
//                 />

//                 {/* A lista de filhos agora é renderizada DENTRO da mesma tag do item pai */}
//                 {hasSubItems && renderChapterItems(item.items, parentChapter)}
//               </li>
//             );
//           })}
//         </ChapterItems>
//       );
//     },
//     [
//       createChapterLink,
//       createContentSearchResultFromChapter,
//       history,
//       currentEdition
//     ]
//   );
//   return (
//     <AsyncComponent
//       error={
//         editionChaptersRequest.error &&
//         _.get(editionChaptersRequest.error, 'response.status') === 500
//       }
//       loading={editionChaptersRequest.loading}
//       renderContent={() => {
//         if (!editionChaptersRequest.result) return null;

//         const groupedChaptersBySubtitle = _.groupBy(
//           editionChaptersRequest.result,
//           'subtitle'
//         );

//         const printSubtitles = [
//           { subtitle: 'Pré textual', label: 'Pré-Textual' },
//           { subtitle: 'Capítulos', label: 'Capítulos' },
//           { subtitle: 'Pós textual', label: 'Pós-Textual' }
//         ];

//         return ['Pré textual', 'Capítulos', 'Pós textual'].map((subtitle) => {
//           const chapters = groupedChaptersBySubtitle[subtitle];

//           if (!chapters) {
//             console.warn('lista de capitulos vazia');
//             return null;
//           }

//           const isMainChapters = subtitle === 'Capítulos';

//           return (
//             <div key={subtitle}>
//               <h3 style={{ marginTop: '1rem' }}>
//                 {printSubtitles.find((p) => p.subtitle === subtitle).label ||
//                   subtitle}
//               </h3>
//               <EvenlySpacedItemsList>
//                 {/* {chapters.map(
//                   (chapter: BookEditionChapterModel, index: number) => (
//                     <React.Fragment key={`${chapter.id}-${index}`}>
//                       <ArticleListItem
//                         article={chapter}
//                         link={createChapterLink(chapter.id)}
//                         active={selectedChapterId === chapter.id}
//                         onClick={() => {
//                           history.push(createChapterLink(chapter.id));
//                         }}
//                         Menu={
//                           currentEdition && currentEdition.onlyView ? (
//                             <Icon type="lock" style={{ fontSize: 30 }} />
//                           ) : (
//                             <div
//                               style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '0.5rem'
//                               }}>
//                               {isMainChapters && (
//                                 <AISummaryButton
//                                   source={{
//                                     kind: 'book',
//                                     bookId: bookId || book.id,
//                                     editionId,
//                                     chapterId: chapter.id
//                                   }}
//                                   variant="compact"
//                                 />
//                               )}

//                               <DotsContentMenu
//                                 result={createContentSearchResultFromChapter(
//                                   chapter
//                                 )}
//                               />
//                             </div>
//                           )
//                         }
//                       />

//                       {chapter.items && chapter.items.length > 0
//                         ? renderChapterItems(chapter.items, chapter)
//                         : null}
//                     </React.Fragment>
//                   )
//                 )} */}
//                 {chapters.map(
//                   (chapter: BookEditionChapterModel, index: number) => (
//                     // Em vez de React.Fragment, envolva o pai e os subitens num único container
//                     <div key={`${chapter.id}-${index}`}>
//                       <ArticleListItem
//                         article={chapter}
//                         link={createChapterLink(chapter.id)}
//                         active={selectedChapterId === chapter.id}
//                         onClick={() => {
//                           history.push(createChapterLink(chapter.id));
//                         }}
//                         Menu={
//                           currentEdition && currentEdition.onlyView ? (
//                             <Icon type="lock" style={{ fontSize: 30 }} />
//                           ) : (
//                             <div
//                               style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '0.5rem'
//                               }}>
//                               {isMainChapters && (
//                                 <AISummaryButton
//                                   source={{
//                                     kind: 'book',
//                                     bookId: bookId || book.id,
//                                     editionId,
//                                     chapterId: chapter.id
//                                   }}
//                                   variant="compact"
//                                 />
//                               )}

//                               <DotsContentMenu
//                                 result={createContentSearchResultFromChapter(
//                                   chapter
//                                 )}
//                               />
//                             </div>
//                           )
//                         }
//                       />

//                       {/* Os subitens ficam agrupados na mesma div pai do capítulo principal */}
//                       {chapter.items && chapter.items.length > 0
//                         ? renderChapterItems(chapter.items, chapter)
//                         : null}
//                     </div>
//                   )
//                 )}
//               </EvenlySpacedItemsList>
//             </div>
//           );
//         });
//       }}
//     />
//   );
// };

// const ChapterTreeNode = ({
//   chapter,
//   item,
//   currentEdition,
//   selectedChapterId,
//   createChapterLink,
//   createContentSearchResultFromChapter,
//   history,
//   level = 0
// }: {
//   chapter: BookEditionChapterModel;
//   item?: BookChapterItemModel;
//   currentEdition?: any;
//   selectedChapterId?: number;
//   createChapterLink: (chapterId: any, digitalPage?: number) => string;
//   createContentSearchResultFromChapter: (
//     chapter: BookEditionChapterModel
//   ) => ContentSearchResult;
//   history: any;
//   level?: number;
// }) => {
//   const isItem = !!item;

//   const article = isItem
//     ? new BookEditionChapterModel(
//         chapter.id,
//         item.title,
//         chapter.author,
//         chapter.subtitle,
//         chapter.pdfName,
//         chapter.titlePresentation,
//         item.items || []
//       )
//     : chapter;

//   const link = isItem
//     ? createChapterLink(chapter.id, item.digitalPage)
//     : createChapterLink(chapter.id);

//   return (
//     <ArticleListItem
//       article={article}
//       link={link}
//       active={!isItem && selectedChapterId === chapter.id}
//       onClick={() => {
//         history.push(link);
//       }}
//       Menu={
//         currentEdition && currentEdition.onlyView ? (
//           <Icon type="lock" style={{ fontSize: 30 }} />
//         ) : (
//           <DotsContentMenu
//             result={createContentSearchResultFromChapter(chapter)}
//           />
//         )
//       }
//     />
//   );
// };
// const ChapterItems = styled.div`
//   margin-left: 40px;
// `;
// //@ts-ignore
// export const BookEditionChapterList = withRouter(_BookEditionChapterList);

/* eslint-disable @typescript-eslint/naming-convention */
import _ from 'lodash';
import React, { useCallback, useContext } from 'react';
import { withRouter } from 'react-router';
import { AsyncComponent } from '../../../components/AsyncComponent';
import { DotsContentMenu } from '../../../components/ContentMenu/DotsContentMenu';
import { EvenlySpacedItemsList } from '../../../components/EvenlySpacedItemsList';
import { ContentType } from '../../../enums/ContentType';
import { AISummaryButton } from '../../../features/ai_summary';
import { BookContextModel } from '../../../models/book/BookContextModel';
import { BookEditionChapterModel } from '../../../models/book/BookEditionChapterModel';
import { BookEditionModel } from '../../../models/book/BookEditionModel';
import { ContentSearchResult } from '../../../models/ContentSearchResult';
import { ArticleListItem } from '../../periodico/components/ArticleListItem';
import { BookContext } from './BookContextProvider';
import { Icon } from 'antd';
import { BookChapterItemModel } from '../../../models/book/BookChapterItemModel';
import styled from 'styled-components';

interface IProps {
  selectedChapterId?: number;
  match?: any;
  history?: any;
  book: BookEditionModel;
  editionId: number;
  currentEdition?: any;
}

// Wrapper para aplicar o recuo em itens filhos sem criar árvores aninhadas
const FlatListItemWrapper = styled.li<{ level: number }>`
  list-style: none;
  padding-left: ${(props) => props.level * 65}px;
`;

const _BookEditionChapterList = ({
  selectedChapterId,
  match,
  history,
  book,
  currentEdition
}: IProps) => {
  const { bookId, editionId } = match.params;
  const ctx = useContext<{ state: BookContextModel }>(BookContext as any);
  const { editionChaptersRequest } = ctx.state;

  const createChapterLink = useCallback(
    (chapterId: any, digitalPage?: number) => {
      const baseUrl = `/v2/livro/${
        bookId || book.id
      }/${editionId}/${chapterId}`;

      if (digitalPage === undefined || digitalPage === null) {
        return baseUrl;
      }

      return `${baseUrl}?page=${digitalPage}`;
    },
    [book, bookId, editionId]
  );

  const createContentSearchResultFromChapter = useCallback(
    (chapter: BookEditionChapterModel) => {
      if (!book) return ContentSearchResult.Empty;
      const stage = process.env.REACT_APP_STAGE || 'staging';
      const imageSrc = `https://bid1006-${stage}-public.s3.sa-east-1.amazonaws.com${book.image}`;
      return new ContentSearchResult(
        ContentType.CHAPTER,
        chapter.id,
        chapter.title,
        book.title,
        book.description,
        null,
        editionId,
        bookId,
        imageSrc,
        chapter.author,
        null,
        `Atualizado em: ${book.year}`,
        null,
        null,
        book.areasInterest,
        undefined,
        String(chapter.id)
      );
    },
    [book, editionId, bookId]
  );

  // Transforma a estrutura em árvore em um array único e plano (flat)
  const flattenChapterItems = useCallback(
    (
      items: BookChapterItemModel[],
      parentChapter: BookEditionChapterModel,
      level = 1
    ): Array<{
      itemChapter: BookEditionChapterModel;
      link: string;
      level: number;
      key: string;
    }> => {
      if (!items || items.length === 0) return [];

      return items.reduce((acc, item, index) => {
        const link = createChapterLink(parentChapter.id, item.digitalPage);
        const itemChapter = new BookEditionChapterModel(
          parentChapter.id,
          item.title,
          parentChapter.author,
          parentChapter.subtitle,
          parentChapter.pdfName,
          parentChapter.titlePresentation,
          item.items || []
        );

        const currentFlatItem = {
          itemChapter,
          link,
          level,
          key: `${parentChapter.id}-${item.title}-${index}`
        };

        const children =
          item.items && item.items.length > 0
            ? flattenChapterItems(item.items, parentChapter, level + 1)
            : [];

        return [...acc, currentFlatItem, ...children];
      }, [] as Array<{ itemChapter: BookEditionChapterModel; link: string; level: number; key: string }>);
    },
    [createChapterLink]
  );

  return (
    <AsyncComponent
      error={
        editionChaptersRequest.error &&
        _.get(editionChaptersRequest.error, 'response.status') === 500
      }
      loading={editionChaptersRequest.loading}
      renderContent={() => {
        if (!editionChaptersRequest.result) return null;

        const groupedChaptersBySubtitle = _.groupBy(
          editionChaptersRequest.result,
          'subtitle'
        );

        const printSubtitles = [
          { subtitle: 'Pré textual', label: 'Pré-Textual' },
          { subtitle: 'Capítulos', label: 'Capítulos' },
          { subtitle: 'Pós textual', label: 'Pós-Textual' }
        ];

        return ['Pré textual', 'Capítulos', 'Pós textual'].map((subtitle) => {
          const chapters = groupedChaptersBySubtitle[subtitle];

          if (!chapters) {
            console.warn('lista de capitulos vazia');
            return null;
          }

          const isMainChapters = subtitle === 'Capítulos';

          return (
            <div key={subtitle}>
              <h3 style={{ marginTop: '1rem' }}>
                {(() => {
                  const found = printSubtitles.find(
                    (p) => p.subtitle === subtitle
                  );
                  return found ? found.label : subtitle;
                })()}
              </h3>

              <EvenlySpacedItemsList>
                {chapters.map(
                  (chapter: BookEditionChapterModel, index: number) => {
                    // Planifica os subitens deste capítulo
                    const flatSubItems =
                      chapter.items && chapter.items.length > 0
                        ? flattenChapterItems(chapter.items, chapter)
                        : [];

                    return (
                      <React.Fragment key={`${chapter.id}-${index}`}>
                        {/* Item Pai (Capítulo Principal) */}
                        <FlatListItemWrapper level={0}>
                          <ArticleListItem
                            article={chapter}
                            link={createChapterLink(chapter.id)}
                            active={selectedChapterId === chapter.id}
                            onClick={() => {
                              history.push(createChapterLink(chapter.id));
                            }}
                            Menu={
                              currentEdition && currentEdition.onlyView ? (
                                <Icon type="lock" style={{ fontSize: 30 }} />
                              ) : (
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem'
                                  }}>
                                  {isMainChapters && (
                                    <AISummaryButton
                                      source={{
                                        kind: 'book',
                                        bookId: bookId || book.id,
                                        editionId,
                                        chapterId: chapter.id
                                      }}
                                      variant="compact"
                                    />
                                  )}

                                  <DotsContentMenu
                                    result={createContentSearchResultFromChapter(
                                      chapter
                                    )}
                                  />
                                </div>
                              )
                            }
                          />
                        </FlatListItemWrapper>

                        {/* Itens Filhos no mesmo nível (sem sub-árvore/divs intermediárias) */}
                        {flatSubItems.map((subItem) => (
                          <FlatListItemWrapper
                            key={subItem.key}
                            level={subItem.level}>
                            <ArticleListItem
                              article={subItem.itemChapter}
                              link={subItem.link}
                              active={false}
                              onClick={() => {
                                history.push(subItem.link);
                              }}
                              Menu={
                                currentEdition && currentEdition.onlyView ? (
                                  <Icon type="lock" style={{ fontSize: 30 }} />
                                ) : (
                                  <DotsContentMenu
                                    result={createContentSearchResultFromChapter(
                                      chapter
                                    )}
                                  />
                                )
                              }
                            />
                          </FlatListItemWrapper>
                        ))}
                      </React.Fragment>
                    );
                  }
                )}
              </EvenlySpacedItemsList>
            </div>
          );
        });
      }}
    />
  );
};

//@ts-ignore
export const BookEditionChapterList = withRouter(_BookEditionChapterList);
